<template>
  <div class="main-content-wrapper">
    <div class="content pt-4 pb-0 pl-0 pr-0">
      <div class="container">
        <div class="row justify-content-center">
          <!-- Main Welcome Card -->
          <div class="col-lg-10 col-md-12">
            <div class="welcome-card shadow-lg mb-5">
              <div class="card-body p-4 p-md-5">
                <div class="row align-items-center mb-4">
                  <div class="col-auto">
                    <div class="logo-container">
                      <img
                        src="@/assets/img/logo.png"
                        class="img-fluid"
                        alt="Logo"
                      />
                    </div>
                  </div>
                  <div class="col">
                    <h2 class="welcome-title mb-0">¡Hola, <strong>{{ user.full_name }}</strong>!</h2>
                    <p class="text-muted current-date mb-0">{{ humanDate(new Date()) }}</p>
                  </div>
                </div>

                <div class="divider mb-4"></div>

                <div class="section-header d-flex align-items-center mb-4">
                  <div class="orange-dot mr-2"></div>
                  <h3 class="section-title mb-0">Rutas en proceso</h3>
                </div>

                <div class="row">
                  <div v-for="service in routes" :key="service.id" class="col-xl-6 col-lg-6 col-md-12 mb-4">
                    <RouteCard :route="service" />
                  </div>
                  
                  <!-- Empty State -->
                  <div v-if="routes.length === 0 && !isBusy" class="col-12 text-center py-5 mt-3">
                    <div class="empty-state text-muted opacity-50">
                      <v-icon name="route" scale="4" class="mb-3"></v-icon>
                      <p class="text-secondary font-weight-bold">No tienes rutas activas en este momento</p>
                      <button class="btn btn-primary mt-2 px-4 shadow-sm" style="border-radius: 20px;">
                        Nueva Ruta
                      </button>
                    </div>
                  </div>

                  <!-- Loading State -->
                  <div v-if="isBusy && routes.length === 0 && completedRoutes.length === 0" class="col-12 text-center py-5">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Cargando...</span>
                    </div>
                  </div>
                </div>

                <!-- Executed Routes Section -->
                <div v-if="completedRoutes.length > 0" class="executed-routes-wrapper mt-5">
                  <div class="section-header d-flex align-items-center mb-4">
                    <div class="blue-dot mr-2"></div>
                    <h3 class="section-title mb-0">Rutas ejecutadas</h3>
                  </div>
                  <div class="row">
                    <div v-for="service in completedRoutes" :key="service.id" class="col-xl-6 col-lg-6 col-md-12 mb-4">
                      <RouteCard :route="service" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import RouteCard from './Component/RouteCard.vue'
import jsCookie from 'js-cookie';
export default {
  name: 'RouteHome',
  components: {
    RouteCard
  },
  data() {
    return {
      HelloWorld: 'Inicio de Rutas',
      routes: [],
      completedRoutes: [],
      isBusy: false,
      user:{ },
      metaInfo: {
        current_page: 1,
        last_page: 1
      }
    }
  },
  methods: {
    ...mapActions(['getData', 'changeStatusData']),
    viewDetail(service) {
      if (service && service.id) {
        console.log("Navigating to service ID:", service.id)
        this.$router.push({ name: 'ServiceDetail', params: { id: service.id } })
      } else {
        console.error("No service ID found in object:", service)
      }
    },
    loadChildren(id_user) {
      let form = {
        url: 'user_children/all',
        params: {
          id_user_parent: this.user.id,
          active: 1,
          order_by: 'id',
          order_key: 'desc'
        }
      }
        this.getData(form)
          .then((response) => {
            this.childrens = response.data

            //foreach children
            this.childrens.forEach((children) => {
              if(children.id > 0){
                this.loadElements(children.id)
              }
            });
             
          })
          .catch((error) => {
            console.log(error)
          })
          
    
  },
    loadElements(id_children) {
      // Load active routes (1-5)
      this.fetchRoutesByStatus(id_children, '[1,2,3,4,5]', 'routes')
      // Load completed routes (6) - Only last 10
      this.fetchRoutesByStatus(id_children, '6', 'completedRoutes', 10)
    },
    fetchRoutesByStatus(id_children, statuses, targetArray, limit = null) {
      let form = {
        url: 'service/all',
        params: {
          id_user_children: id_children,
          active:1,
          id_status_service: statuses,
          order_key: 'id',
          order_value: 'desc',
        }
      }

      if (limit) {
        form.params.limit = limit
      }

      if (this.finder != '') {
        form.params.query = this.finder
      }
      
      this.isBusy = true
      this.getData(form)
        .then((response) => {
          this.isBusy = false
          if (response.code === 200) {
            // Extract data array from response (handle both array and paginated format)
            const newRoutes = Array.isArray(response.data) ? response.data : (response.data.data || [])
            
            //If target array already have elements, push new elements
            if (this[targetArray].length > 0) {
              this[targetArray] = this[targetArray].concat(newRoutes)
            } else {
              this[targetArray] = newRoutes
            }
            console.log(`Loaded ${targetArray}:`, this[targetArray])
          }
        })
        .catch((error) => {
          console.error(error)
          this.isBusy = false
        })
    },
    humanDate(date) {
      //Format in legible date
      moment.locale('es')
      return moment(date).format('dddd DD [de] MMMM [de] YYYY')
    }
  },
  mounted() {
    //get user from cookie
    let user = jsCookie.get('user')
    //format json data
    this.user = JSON.parse(user)

    if(this.user){
      this.loadChildren(this.user.id)
    }
    
    
    
    
    
  }
}
</script>

<style scoped>
.main-content-wrapper {
  background: linear-gradient(135deg, #f76e2a 0%, #ff9e6d 100%);
  min-height: 100vh;
  padding-bottom: 2rem;
}

.welcome-card {
  border: none;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  overflow: hidden;
}

.logo-container {
  width: 70px;
  height: 70px;
  background: white;
  border-radius: 18px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
}

.welcome-title {
  font-size: 1.8rem;
  color: #2D3748;
  font-weight: 500;
}

.current-date {
  font-size: 0.95rem;
  letter-spacing: 0.5px;
}

.divider {
  height: 1px;
  background: linear-gradient(to right, #eee, transparent);
}

.orange-dot {
  width: 8px;
  height: 8px;
  background-color: #f76e2a;
  border-radius: 50%;
}

.blue-dot {
  width: 8px;
  height: 8px;
  background-color: #3182ce;
  border-radius: 50%;
}

.section-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #4A5568;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.empty-state i {
  color: #cbd5e0;
}

/* Transitions */
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

@media (max-width: 768px) {
  .welcome-title {
    font-size: 1.4rem;
  }
}
</style>
